// extracted by mini-css-extract-plugin
module.exports = {"text-content":"RichTextContent_text-content__bEmCk","text-body":"RichTextContent_text-body__l_7PL"};